import { render, staticRenderFns } from "./entrance.vue?vue&type=template&id=8681373e"
import script from "./entrance.vue?vue&type=script&lang=js"
export * from "./entrance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports